<template>
  <div>
    <div><strong>{{title}}</strong></div>
    <div><i>{{created_on}}</i></div>
    <div>link {{urlId}}</div>
  </div>
</template>

<script>
export default {
  name:"Protocol",
  props:{
    title: String,
    created_on: String,
    urlId: Number
  }
}
</script>
